import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core'
import { CONTENT_TYPE, SOURCE_TYPE, LANGUAGES } from '../../Features/AddNewLTDDocument/@types'
import FormGroup, { IFormConfig } from '../FormGroup'
import { connect } from 'react-redux'
import _ from 'lodash';
import { ONewLTDDocument } from '../../Features/AddNewLTDDocument/redux-config'
import { OApp } from '../../RootReducer/AppReducer'
import { TState } from '../../RootReducer/index';
import SearchAdd from '../SearchAdd'
import DragReorderList from '../DragReorderList'
import PurlResource from '../PurlResource';
import { WithTranslationProps, withTranslations } from '../../Features/Translations/withTranslations'
import { METADATA_ICC_CASECITED, METADATA_LEGISLATION, METADATA_ORGANISATION_JUDICAL, METADATA_RELATED_ORGANISATION, METADATA_RELATED_RESOURCE } from '../../Features/Translations/translationKeys.ltd'

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps { }


interface IStateProps {
    formData: Record<string, any>
}

interface IDispatchProps {
    setFormField: (key: string, value: any) => void
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => void,
}



class Relations extends Component<IProps & WithTranslationProps> {
    state = {
        list: []
    }

    componentDidMount() {
        this.setState({ list: _.map((_.get(this.props.formData, 'relatedDocs') || []), val => ({ ...val, name: val.title })) })
    }

    onReorder = (newList: any) => {
        this.setState({ list: newList })
        this.props.setFormField('relatedDocIds', newList.map(item => item.id));
    }


    handleChange = (e: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(e.target.name, e.target.value)
        }
    }

    handleSuggestion = ({ name, value }) => {
        if (name === 'relatedDocIds') {
            return;
        }
        this.props.setFormField(name, value);
    }


    handleRelationSelect = ({ name, value }) => {
        const list = [...this.state.list, value]
        this.setState({ list });
        this.props.setFormField(name, list.map(item => item.id));
    }


    handleRemoveItem = (index: number) => {
        const newList = _.filter(this.state.list, (item, i) => i !== index);
        this.props.setFormField('relatedDocIds', newList.map(item => _.get(item, 'id')))
        this.setState({ list: newList });
    }


    render() {
        const { classes, formData, getTranslation } = this.props

        const FORM_CONFIG: IFormConfig[][] = [
            [
                {
                    label: getTranslation(METADATA_RELATED_ORGANISATION)
                    , key: 'relatedOrganisation', type: 'component', onChange: this.handleChange, component: (
                        <SearchAdd
                            label={getTranslation(METADATA_RELATED_ORGANISATION) || "Related organisation/ State"}
                            formKey="relatedOrganisation"
                            key="relatedOrganisation"
                            value={formData['relatedOrganisation'] || ''}
                            onChange={this.handleSuggestion}
                            suggestionUrl="ltddocs/autocomplete"
                            params={(term) => ({ term, field: 'relatedOrganisation' })}
                            handleSuggestions={(data) => data.map(val => val['relatedOrganisation'])}
                        />
                    )
                },
                {
                    label: getTranslation(METADATA_ORGANISATION_JUDICAL) || 'Organisation/ State of judicial body',
                    key: 'Organisation/ State of judicial body', type: 'component', onChange: this.handleChange, component: (
                        <SearchAdd
                            label={getTranslation(METADATA_ORGANISATION_JUDICAL) || "Organisation/ State of judicial body"}
                            formKey="orgaisationJudicialBody"
                            key="orgaisationJudicialBody"
                            value={formData['orgaisationJudicialBody'] || ''}
                            onChange={this.handleSuggestion}
                            suggestionUrl="ltddocs/autocomplete"
                            params={(term) => ({ term, field: 'orgaisationJudicialBody' })}
                            handleSuggestions={(data) => data.map(val => val['orgaisationJudicialBody'])}
                        />
                    )
                },
            ],
            [
                {
                    label: 'Related resource', key: 'Related resource', type: 'component', onChange: this.handleChange, component: (
                        <div className="my-3">
                            {/* <SearchAdd
                                objectValue
                                disableAdd
                                searchKey='title'
                                label="Related resource"
                                formKey="relatedDocIds"
                                key="relatedDocIds"
                                onChange={this.handleSuggestion}
                                onSelect={this.handleRelationSelect}
                                suggestionUrl="ltddocs/autocomplete"
                                params={(val: string) => ({ term: val, field: 'title' })}
                                handleSuggestions={(data) => data.map(val => ({ name: val['title'], id: val['id'] }))}
                            /> */}
                            <PurlResource
                                formKey="relatedDocIds"
                                label={getTranslation(METADATA_RELATED_RESOURCE) || "Related resource"}
                                placeholder="PURL of the document"
                                onSelect={this.handleRelationSelect}
                            />
                            <DragReorderList
                                id="relatedResources"
                                list={this.state.list}
                                onReorder={this.onReorder}
                                onRemove={this.handleRemoveItem}
                            />
                        </div>
                    )
                },
            ],

            [
                { label: getTranslation(METADATA_ICC_CASECITED) || 'ICC case(s) cited', key: 'ICC case(s) cited', type: 'multiline', onChange: this.handleChange },
            ],
            [
                { label: getTranslation(METADATA_LEGISLATION) || 'Legislation cited', key: 'Legislation cited', type: 'multiline', onChange: this.handleChange },
            ],
        ]

        return (
            <>
                <FormGroup classes={{ root: classes.formContainer }} formData={formData} formItems={FORM_CONFIG} />
            </>
        )
    }
}

const STYLES = (theme: Theme) => createStyles({
    formContainer: {
        [theme.breakpoints.down('sm')]: {
            width: '95vw',
        }
    }
})



const mapStateToProps = (state: TState): IStateProps => ({
    ..._.pick(state.NewLTDDocument, ['formData'])
});


const mapDispatchToProps = (dispatch): IDispatchProps => ({
    setFormField: (k: string, v: any) => dispatch(ONewLTDDocument.setFormField(k, v)),
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => dispatch(OApp.showConfirmationDialog(msg, onConfirm, onCancel)),

})



export default withStyles(STYLES)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(Relations)))